'use client';

import { useMyPopTopic } from '@fe-news/context/my-pop-topic-provider';
import { styled } from '@linaria/react';
import InfiniteCard from './InfiniteCard';
import InfiniteCardLazy from './InfiniteCardLazy';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 24px;
  row-gap: 34px;
`;

const PopTopicInfiniteList = () => {
  const { myCollectionDataItemsIdArray } = useMyPopTopic();

  return (
    <Container>
      {myCollectionDataItemsIdArray?.length > 0 &&
        myCollectionDataItemsIdArray?.map((id, index) => {
          return index < 3 ? (
            <InfiniteCard key={`infinite_card_${id}`} id={id} />
          ) : (
            <InfiniteCardLazy key={`infinite_card_${id}`} id={id} />
          );
        })}
    </Container>
  );
};

export default PopTopicInfiniteList;
